import React from 'react';
import { Button, Result, Space } from 'antd';
import { basename } from '../../../Constants/env';
import './ErrorBoundary.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details for debugging/telemetry
    // Replace with your logging service if available
    console.error('React ErrorBoundary caught an error:', error);
    console.error('Error info:', errorInfo);
    this.setState({ error, errorInfo });
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  handleReturnHome = () => {
    window.location.assign(basename || '/');
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="error-boundary" role="alert">
          <section className="error-boundary__card">
            <Result
              icon={<div className="error-boundary__icon" aria-hidden="true">!</div>}
              title="We hit a small snag"
              subTitle="Your work is safe. Try again, or return to your dashboard and continue from there."
              extra={
                <Space wrap size={12}>
                  <Button type="primary" size="large" onClick={this.handleRetry}>Try again</Button>
                  <Button size="large" onClick={this.handleReturnHome}>Go to dashboard</Button>
                </Space>
              }
            />
            <p className="error-boundary__help">Still stuck? Contact <a href="mailto:contact@custom-answer.com">support</a>.</p>
          </section>
        </main>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;


